import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { canadaGibsonFont } from "../Config";

export default function RHFDatePicker({
    name,
    label,
    control,
    defaultValue = "",
    errors,
    disabled = false,
    trigger,
    ...muiProps
}) {
    const fieldError = name.split(".").reduce((obj, key) => obj?.[key], errors);

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={(field, fieldState) => (
                <TextField
                    {...field}
                    type="date"
                    label={label}
                    disabled={disabled}
                    error={!!fieldState.invalid}
                    helperText={fieldError?.message}
                    fullWidth
                    sx={canadaGibsonFont}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(e) => {
                        field.onChange(e.target.value);
                        trigger(name);
                    }}
                    {...muiProps}
                />
            )}
        />
    );
}
